import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosHttp from 'services/axiosHttp';
import dayjs from 'dayjs';

export const fetchQrSummeryList = createAsyncThunk('qrSummeryList/fetchQrSummeryList', async (filters = {}, { rejectWithValue }) => {
    try {
      const params = {
        servicetype: filters.qr_type || undefined,
        department: filters.department || undefined,
        date_start: filters.date ? dayjs(filters.date).format('YYYY-MM-DD') : undefined,
        date_end: filters.date ? dayjs(filters.date).format('YYYY-MM-DD') : undefined
      };
      
      const response = await axiosHttp.get('lcqr/getlogsummary', { params });
      
      if (response.data && response.data.success) {
        return response.data.data[0] || {
          depdata: [],
          locationdata: [],
          qrtypeslog: []
        };
      } else {
        return rejectWithValue(response.data?.message || 'Failed to fetch QR Summary');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);

const qrSummeryListSlice = createSlice({
  name: 'QrSummeryListSlice',
  initialState: {
    depdata: [],
    locationdata: [],
    qrtypeslog: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQrSummeryList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQrSummeryList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.depdata = action.payload.depdata || [];
        state.locationdata = action.payload.locationdata || [];
        state.qrtypeslog = action.payload.qrtypeslog || [];
      })
      .addCase(fetchQrSummeryList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default qrSummeryListSlice.reducer;
